import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import CompaniesPagesRepository from '@/application/repositories/CompaniesPagesRepository';
import ProductRepository from '@/application/repositories/ProductRepository';
import ProductDto from '@/application/dto/ProductDto';
import CompanyDto from '@/application/dto/CompanyDto';
import Modal from '@/components/Modal';
import Loading from '@/components/Loading';
import { useAppStore } from '@/store';

import ProductItem from './components/ProductItem';
import {
  BannerImg,
  BannerWrapper,
  ProductsContainer,
  ProductsList,
  RegulationContainer,
} from './style';

// import redesCinemas from '@/assets/img/cinema-rodape.png';

import './style.css';
import Layout from '../Layout';

const productRepository = new ProductRepository();
const companiesPagesRepository = new CompaniesPagesRepository();

const Products = () => {
  const { companiesSlug } = useParams();
  const navigate = useNavigate();

  const {
    appStore: { banner, regulation, scriptContent },
  } = useAppStore();
  const [products, setProducts] = useState<ProductDto[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<ProductDto>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        if (companiesSlug === undefined) {
          return;
        }

        setLoading(true);

        const companyDto: CompanyDto = await companiesPagesRepository.getBySlug(
          companiesSlug as string
        );

        if (!companyDto.uuid) {
          navigate(`/not-found`, {
            state: {},
          });
        }

        setProducts(
          await productRepository.getByCompaniesPagesId(companyDto.uuid)
        );
      } catch (error) {
      } finally {
        setLoading(false);
      }
    })();
  }, [companiesSlug]);

  return (
    <Layout>
      <div>
        {banner && (
          <BannerWrapper>
            <BannerImg src={banner} />
          </BannerWrapper>
        )}

        <ProductsContainer>
          <div className="titles">
            <h1 className="title">
              É só escolher uma das opções abaixo e se divertir!
            </h1>
          </div>

          <Loading show={loading} text="Carregando..." />

          <ProductsList quantity={products.length}>
            {products.map((product, index) => (
              <ProductItem
                key={index}
                product={product}
                companiesSlug={companiesSlug as string}
                onClickMoreInfo={(product) => {
                  setSelectedProduct(product);
                }}
              />
            ))}
          </ProductsList>
        </ProductsContainer>

        {/* <BannerWrapper style={{ marginTop: '70px' }}>
        <BannerImg src={redesCinemas} />
      </BannerWrapper> */}

        {scriptContent && (
          <div
            className="script-content"
            dangerouslySetInnerHTML={{ __html: scriptContent }}
          />
        )}

        {regulation && (
          <RegulationContainer
            dangerouslySetInnerHTML={{ __html: regulation }}
          />
        )}

        <Modal
          title={`Mais informações - ${
            selectedProduct?.name && selectedProduct?.name
          }`}
          text={selectedProduct?.moreInfo}
          isOpen={!!selectedProduct}
          onClose={() => setSelectedProduct(undefined)}
        />
      </div>
    </Layout>
  );
};

export default Products;
